import { Form, Table } from "react-bootstrap";
import ToolBar from "../../../Componant/ToolBar";
import UseToggle from "../../../../Hooks/UseToggle";
import { useState } from "react";
import AddSubCategory from "./AddSubCategory";
import UpdateSubCategory from "./UpdateSubCategory";
import Moment from "react-moment";
import { useEffect } from "react";
import Swal from "sweetalert2";
import { blogSubCategoryServices } from "../../../../APIServices/SitePilotManagement/BlogManagement/blogSubCategoryServices";

const SubCategoryManagement = ({blogCategories}) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [blogSubCategories, setBlogSubCategories] = useState([]);
  const [blogSubCategoryData, setBlogSubCategoryData] = useState("");
  const [blogSubCategoryCount, setBlogSubCategoryCount] = useState(0);
  const [blogSubCategoryIds, setBlogSubCategoryIds] = useState([]);

  const toggleSingle = (id) => {
    setBlogSubCategoryIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (blogSubCategoryIds.length === blogSubCategories.length) {
      setBlogSubCategoryIds([]);
    } else {
      setBlogSubCategoryIds(blogSubCategories.map((c) => c.id));
    }
  };

  const isAllChecked =
    blogSubCategories.length > 0 && blogSubCategoryIds.length === blogSubCategories.length;
  const isChecked = (id) => blogSubCategoryIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(blogSubCategoryCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, blogSubCategoryCount);

  const getBlogSubCategoryList = async () => {
    setLoader(true);
    let data = await blogSubCategoryServices.getBlogSubCategoryList(
      "all",
      "all",
      search,
      pageNumber,
      itemsPerPage,
    );
    setBlogSubCategories(data?.data || []);
    setBlogSubCategoryCount(data?.count || 0);
    setLoader(false);
  };

  const updatedBlogSubCategory = async (subCategoryId, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status} this Blog Sub Category?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.subCategoryId = subCategoryId;
        userData.status = status;
        let data = await blogSubCategoryServices.updatedBlogSubCategory(userData);
        if (data?.statusCode === 200) {
          getBlogSubCategoryList();
        }
      }
    });
  };

  const deleteBlogSubCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Blog Sub Category?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.subCategoryIds = blogSubCategoryIds;
        let data = await blogSubCategoryServices.deleteBlogSubCategory(userData);
        if (data?.statusCode === 200) {
          getBlogSubCategoryList();
        }
      }
    });
  };

  useEffect(() => {
    let blogSubCategoryData = blogSubCategories?.find(
      (item) => item.subCategoryId === blogSubCategoryIds?.[0],
    );
    setBlogSubCategoryData(blogSubCategoryData || "");
  }, [blogSubCategoryIds]);

  useEffect(() => {
    getBlogSubCategoryList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <ToolBar
        toggles={toggles}
        search={search}
        setSearch={setSearch}
        checkedIds={blogSubCategoryIds}
        setCheckedIds={setBlogSubCategoryIds}
        start={start}
        end={end}
        totalItems={blogSubCategoryCount}
        page={pageNumber}
        setPage={setPageNumber}
        setPageSize={setItemsPerPage}
        pageSize={itemsPerPage}
        totalPages={totalPages}
        deleteData={deleteBlogSubCategory}
        addField
        editField
      />
      <div className={`contacts-layout`}>
        <div
          className={`table-section overflow-auto bg-white `}
          style={{ height: "calc(100vh - 182px)" }}
        >
          <Table
            hover
            className="contacts-table mb-0"
            style={{ verticalAlign: "middle" }}
          >
            <thead>
              <tr>
                <th>
                  <div className="d-flex align-items-center gap-2">
                    <div className="px-2">
                      <Form.Check
                        type="checkbox"
                        checked={isAllChecked}
                        onChange={toggleAll}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    <div>Sub Category</div>
                  </div>
                </th>
                <th>Category</th>
                <th>Total Post</th>
                <th>Status</th>
                <th>Created Date | Time</th>
                <th>Updated Date | Time</th>
              </tr>
            </thead>
            <tbody>
              {blogSubCategories?.map((item) => (
                <tr key={item.subCategoryId}>
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isChecked(item.subCategoryId)}
                          onChange={() => toggleSingle(item.subCategoryId)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>
                        <div className="fw-medium">{item.name}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="fw-medium">{item.categoryName}</span>
                  </td>
                  <td>
                    <span className="fw-medium">{item.totalPost || 0}</span>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      onChange={() =>
                        updatedBlogSubCategory(
                          item?.subCategoryId,
                          item.status === "active" ? "inactive" : "active",
                        )
                      }
                      checked={item.status === "active"}
                    />
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </span>
                  </td>
                  <td>
                    <span className="fw-medium">
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.updatedAt}
                      </Moment>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <AddSubCategory
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Sub Category`}
        getBlogSubCategoryList={getBlogSubCategoryList}
        blogCategories={blogCategories}
      />
      <UpdateSubCategory
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Sub Category`}
        blogSubCategoryData={blogSubCategoryData}
        setBlogSubCategoryData={setBlogSubCategoryData}
        setBlogSubCategoryIds={setBlogSubCategoryIds}
        getBlogSubCategoryList={getBlogSubCategoryList}
      />
    </>
  );
};

export default SubCategoryManagement;
